<ion-content *ngIf="isLive">
	<app-public-layout [clientLogoImg]="this.appCoreService.clientConfig?.publicLayout?.clientLogo">
		<div class="app-public-layout-content text-wrapper" *ngIf="loaded">
			<p class="text-line">
				{{ 'MAINTENANCE_TEXT' | translate }}
			</p>
			<p class="text-line">
				{{ 'MAINTENANCE_TEXT2' | translate }}
			</p>
		</div>
	</app-public-layout>
</ion-content>

<div *ngIf="!isLive">
	<ion-content class="site-down-content">
		<div class="public-layout-wrapper">
			<div class="portal-welcome header-filler"></div>
			<div class="landing-page-container">
				<div class="app-bg-img hidden-xs hidden-sm"></div>
				<!--Main Card for logging in and other account options-->
				<div class="login-form-card">
					<ion-ahs-card>
						<div class="ion-ahs-card-content">
							Our website is currently undergoing scheduled maintenance to provide you with a better
							experience. We apologize for any inconvenience this may cause and appreciate your patience.
						</div>
						<div class="ion-ahs-card-content down-text">
							Nuestro sitio web se encuentra actualmente en mantenimiento programado para brindarle una
							mejor experiencia. Nos disculpamos por cualquier inconveniente que esto pueda causar y
							agradecemos su paciencia.
						</div>
						<div class="ion-ahs-card-content down-text">
							Trang web của chúng tôi hiện đang được bảo trì theo lịch trình để cung cấp cho bạn trải
							nghiệm tốt hơn. Chúng tôi xin lỗi vì bất kỳ sự bất tiện nào mà điều này có thể gây ra và
							đánh giá cao sự kiên nhẫn của bạn.
						</div>
						<div class="ion-ahs-card-content down-text">
							我们的网站目前正在进行定期维护，以便为您提供更好的体验。对于由此造成的任何不便，我们深表歉意，并感谢您的耐心等待。
						</div>
						<div class="ion-ahs-card-content down-text">
							Mareegtayada ayaa hadda ku socota dayactir la qorsheeyay si ay kuu siiso khibrad wanaagsan.
							Waan ka cudur daaranaynaa wixii dhib ah ee ay tani keeni karto, waxaanan uga mahadcelinaynaa
							dulqaadkaaga.
						</div>
					</ion-ahs-card>
				</div>
			</div>
			<div class="footer-wrapper">
				<div id="copyright" class="footer-bottom copyright">
					<div class="container">
						<div class="copyright-links-left">
							© {{ currentYear }}
							<a href="http://www.automated-health.com" target="_blank">Automated Health Systems, Inc.</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ion-content>
</div>
